import { render, staticRenderFns } from "./V2Operations.vue?vue&type=template&id=ecf428e4&scoped=true&"
import script from "./V2Operations.vue?vue&type=script&lang=js&"
export * from "./V2Operations.vue?vue&type=script&lang=js&"
import style0 from "./V2Operations.vue?vue&type=style&index=0&id=ecf428e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf428e4",
  null
  
)

export default component.exports